declare global {
	interface Window {
		getIsLocked: () => boolean;
	}
}

export const getIsLocked = function () {
	return false;
};
